import React from 'react';
import content from '../../Data/career_internships.json';
import './internship_cards.css';

function InternshipCards() {
  return (
    <div className="career-internships">
      <p className="career-internship-title">Openings</p>
      <div className="internship-row-container">
        {content.cards.map((card, index) => (
          <div key={index} className="career-internship-roles">
            <div
              className="career-internship-card card shadow-sm flex-fill"
              style={{
                borderRadius: '24px',
                padding: '30px',
                border: '1px solid #ddd',
              }}
            >
              {/* Title */}
              <h2 className="career-card-title">{card.title}</h2>

              {/* Description */}
              <p className="career-card-description">{card.description}</p>

              {/* Conditions */}
              <p className="career-card-location" style={{ marginBottom: 0 }}>
                {card.Location}
              </p>
              <p className="career-card-duration" style={{ marginBottom: 0 }}>
                {card.Duration}
              </p>
              <p className="career-card-stipend" style={{ marginBottom: 0 }}>
                {card.Stipend}
              </p>
              {/* Button */}
              <button
                className="btn btn-primary mt-2"
                style={{
                  background: '#5A2D7C',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 700,
                }}
              >
                {card.buttonText}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InternshipCards;
